import React from 'react';
import { MDBIcon, MDBBtn } from 'mdbreact';
import { TreeSelect, DatePicker } from 'antd';
import moment from 'moment';
import './addTask.css';
const { TreeNode } = TreeSelect;

class AddTask extends React.Component {
  fileInputRef = React.createRef();

  render() {
    const {
      createTitle,
      createDescription,
      createProject,
      createAssignee,
      createTags,
      createTagName,
      createFiles,      // array of File objects
      createDueDate,
      projects,
      employees,
      isRTL,
      isEdit,
      onClose,
      onTitleChange,
      onDescriptionChange,
      onAssigneeChange,
      onProjectChange,
      onDueDateChange,
      onTagNameChange,
      onAddTag,
      onDeleteTag,
      onFilesChange,    // (newFilesArray) => void
      onCreateTask,
    } = this.props;

    const handleFileSelect = (e) => {
      const selected = Array.from(e.target.files);
      onFilesChange([...createFiles, ...selected]);
      // Reset input so same file can be re-selected
      e.target.value = '';
    };

    const handleRemoveFile = (idx) => {
      onFilesChange(createFiles.filter((_, i) => i !== idx));
    };

    const getFileIcon = (file) => {
      const name = file.name.toLowerCase();
      if (name.endsWith('.xlsx') || name.endsWith('.xls') || name.endsWith('.csv')) return 'file-excel';
      if (name.endsWith('.docx') || name.endsWith('.doc')) return 'file-word';
      if (name.endsWith('.pdf')) return 'file-pdf';
      if (name.endsWith('.png') || name.endsWith('.jpg') || name.endsWith('.jpeg')) return 'file-image';
      return 'file-alt';
    };

    const formatFileSize = (bytes) => {
      if (bytes < 1024) return `${bytes} B`;
      if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`;
      return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
    };

    return (
      <div className="task-drawer-overlay" onClick={onClose}>
        <div className="task-drawer" style={{ padding: '30px' }} onClick={(e) => e.stopPropagation()}>
          <div className="drawer-header" style={{ padding: '0 0 20px', marginBottom: '20px' }}>
            <button className="drawer-close-btn" onClick={onClose}>
              <MDBIcon icon="times" />
            </button>
            <h3 style={{ margin: 0, fontWeight: '700', fontSize: '20px', color: '#1e293b' }}>
              {isEdit ? 'تعديل المهمة' : 'مهمة جديدة'}
            </h3>
          </div>

          <div style={{ display: 'flex', flexDirection: 'column', gap: '20px', overflowY: 'auto', flexGrow: 1, paddingBottom: '20px' }}>

            {/* Title */}
            <div>
              <label className="select-label" style={{ display: 'block', marginBottom: '8px' }}>
                عنوان المهمة <span style={{ color: '#ef4444' }}>*</span>
              </label>
              <input
                type="text"
                placeholder="أدخل عنوان المهمة..."
                className="form-control"
                style={{ fontSize: '14px', height: '42px' }}
                value={createTitle}
                onChange={(e) => onTitleChange(e.target.value)}
              />
            </div>

            {/* Description */}
            <div>
              <label className="select-label" style={{ display: 'block', marginBottom: '8px' }}>
                التفاصيل / الوصف <span style={{ color: '#ef4444' }}>*</span>
              </label>
              <textarea
                placeholder="أدخل تفاصيل المهمة..."
                className="form-control"
                style={{ fontSize: '14px', minHeight: '100px', resize: 'vertical' }}
                value={createDescription}
                onChange={(e) => onDescriptionChange(e.target.value)}
              />
            </div>

            {/* Assignee & Project & Due Date Grid */}
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '20px' }}>

              {/* Assignee */}
              <div>
                <label className="select-label" style={{ display: 'block', marginBottom: '8px' }}>المسؤول (Assignee)</label>
                <TreeSelect
                  virtual={false}
                  value={createAssignee}
                  style={{ width: '100%' }}
                  placeholder="اختر المسؤول"
                  allowClear
                  onChange={(value) => onAssigneeChange(value)}
                >
                  {(employees || []).map(emp => (
                    <TreeNode
                      key={emp.id || emp._id}
                      value={emp.id || emp._id}
                      title={emp.fullname}
                    />
                  ))}
                </TreeSelect>
              </div>

              {/* Project */}
              <div>
                <label className="select-label" style={{ display: 'block', marginBottom: '8px' }}>
                  المشروع <span style={{ color: '#ef4444' }}>*</span>
                </label>
                <TreeSelect
                  virtual={false}
                  value={createProject}
                  style={{ width: '100%' }}
                  placeholder="اختر المشروع"
                  onChange={(value) => onProjectChange(value)}
                >
                  {(projects || []).map(p => (
                    <TreeNode
                      key={p.id || p._id}
                      value={p.id || p._id}
                      title={isRTL ? p.name_ar : p.name_en}
                    />
                  ))}
                </TreeSelect>
              </div>

              {/* Due Date */}
              <div>
                <label className="select-label" style={{ display: 'block', marginBottom: '8px' }}>تاريخ الإنتهاء</label>
                <DatePicker
                  format="YYYY-MM-DD"
                  placeholder="اختر تاريخ الإنتهاء"
                  value={createDueDate ? moment(createDueDate, 'YYYY-MM-DD') : null}
                  onChange={(date, dateString) => onDueDateChange(dateString)}
                  style={{ width: '100%' }}
                />
              </div>

            </div>

            {/* Tags */}
            <div>
              <label className="select-label" style={{ display: 'block', marginBottom: '8px' }}>الوسوم والتاجات</label>
              <div className="task-tags-wrapper" style={{ display: 'flex', gap: '8px', flexWrap: 'wrap', marginBottom: '10px' }}>
                {createTags.map((tag, idx) => (
                  <span
                    key={idx}
                    className="premium-tag"
                    style={{ backgroundColor: tag.color, color: tag.textColor, padding: '4px 10px', borderRadius: '4px', fontSize: '13px' }}
                  >
                    {tag.text}
                    <MDBIcon
                      icon="times"
                      className="tag-delete-icon"
                      style={{ marginRight: '6px', cursor: 'pointer' }}
                      onClick={() => onDeleteTag(tag.text)}
                    />
                  </span>
                ))}
              </div>
              <div className="tag-input-group">
                <input
                  type="text"
                  placeholder="أدخل تاغ جديد..."
                  className="form-control tag-input"
                  value={createTagName}
                  onChange={(e) => onTagNameChange(e.target.value)}
                  onKeyDown={(e) => e.key === 'Enter' && onAddTag()}
                />
                <MDBBtn
                  style={{ width: '80px', background: 'linear-gradient(135deg, #1D9598, #127275)', color: '#fff', borderRadius: '6px', padding: '8px 20px', margin: '0', fontSize: '13px' }}
                  onClick={onAddTag}
                >
                  أضف
                </MDBBtn>
              </div>
            </div>

            {/* File Upload Section */}
            <div>
              <label className="select-label" style={{ display: 'block', marginBottom: '8px' }}>المرفقات</label>

              {/* Selected files list */}
              {createFiles.length > 0 && (
                <div className="attachment-list" style={{ marginBottom: '12px' }}>
                  {createFiles.map((file, idx) => (
                    <div
                      key={idx}
                      className="attachment-item"
                      style={{ padding: '8px 12px', border: '1px solid #e2e8f0', borderRadius: '6px', marginBottom: '8px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}
                    >
                      <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                        <MDBIcon far icon={getFileIcon(file)} style={{ color: '#10b981', fontSize: '18px' }} />
                        <div>
                          <span style={{ fontSize: '13px', fontWeight: '600', display: 'block' }}>{file.name}</span>
                          <span style={{ fontSize: '11px', color: '#94a3b8' }}>{formatFileSize(file.size)}</span>
                        </div>
                      </div>
                      <MDBIcon
                        icon="times"
                        style={{ color: '#ef4444', cursor: 'pointer', fontSize: '14px' }}
                        onClick={() => handleRemoveFile(idx)}
                      />
                    </div>
                  ))}
                </div>
              )}

              {/* Hidden real file input */}
              <input
                type="file"
                multiple
                ref={this.fileInputRef}
                style={{ display: 'none' }}
                onChange={handleFileSelect}
              />

              <button
                className="upload-file-btn"
                onClick={() => this.fileInputRef.current.click()}
              >
                <MDBIcon icon="upload" />
                <span>رفع ملف{createFiles.length > 0 ? ' آخر' : ''}</span>
              </button>
            </div>

          </div>

          {/* Action Footer */}
          <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '12px', borderTop: '1px solid #f1f5f9', paddingTop: '20px' }}>
            <MDBBtn
              color="light"
              style={{ borderRadius: '6px', padding: '10px 24px', margin: '0', fontSize: '14px' }}
              onClick={onClose}
            >
              إلغاء
            </MDBBtn>
            <MDBBtn
              style={{ background: 'linear-gradient(135deg, #1D9598, #127275)', color: '#fff', borderRadius: '6px', padding: '10px 24px', margin: '0', fontSize: '14px' }}
              onClick={onCreateTask}
            >
              {isEdit ? 'حفظ التعديلات' : 'إضافة مهمة'}
            </MDBBtn>
          </div>
        </div>
      </div>
    );
  }
}

export default AddTask;
